import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
// import AnimatedCourseGenerator from "../sections/animatedCourseGenerator"
import Footer from '../sections/footer'

import Navbar from '../sections/navbar'
import MainPage from './mainPage'
import CourseDetail from './courseDetail'
import ContactUs from './contactUs'
import CourseGenerator from './courseGenerator'
import SupportChat from '../components/supportChat'
import FinancialAidScholarship from './financialAidScholarship'
import News from './news'
import MediaCoverage from './mediaCoverage'
import PageNotFound from './pageNotFound'
import CampusLife from './campusLife'
import { routes } from '../routes'
import OurPeoples from './ourPeoples'
import OurPartners from './ourPartners'
import AllProgrammes from './allProgrammes'
import OurAlumniAndCommunities from './ourAlumni'
import InternationalOffices from './internationalOffices'
import About from './about'

import { AnimatePresence } from 'framer-motion'
import Vacancies from './vacancies'
import AcademicCalendar from './academicCalendar'
import Admission from './admission'
import TrainingAndServices from './trainingAndServices'
import RentalFacilities from '../components/trainingAndServices/rentalFacilities'
import Research from './research'
import Irmc from './irmc'
// import Iepre from "./iepre"
import College from './college'
// import ComingSoon from "./comingSoon"
import Faq from './faq'
import Students from './students'
import Staffs from './staffs'
import Announcement from './announcement'
import Quick from './quick'
import Examination from './examination'
import QuickStaff from './quickStaff'
import Registrar from './registrar'
import CustomerSatisfaction from './customerSatisfaction'
import Council from './council'
import CustomerCentre from './customerCentre'
import SmartApps from './smartApps'
import GlobalExchange from './globalExchange'
import Payment from './payment'
import Convocation from './convocation'
import BemGap from './bemGap'
import StudentGuide from './studentGuide'
import YayasanCanselor from './yayasanCanselor'
import Odl from './odl'
import OdlProgrammes from './odl_programmes'
import NewCollege from './newCollege'
import MaintenancePage from './maintainencePage'
import TrainingServicesPages from './trainingServicesPages'
import SearchResults from './searchResults'
import RouteMatch from './routeMatch'

const Home = () => {
  const location = useLocation()

  return (
    <div className='bg-white min-h-screen flex flex-col justify-between'>
      {/* <ScrollToTop/> */}
      <Navbar />
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>
          <Route
            index
            element={
              <RouteMatch>
                <MainPage />
              </RouteMatch>
            }
          />
          <Route
            path='/all-programmes/:field/:name'
            element={
              <RouteMatch>
                <CourseDetail />
              </RouteMatch>
            }
          />
          <Route
            path='/all-programmes/:field'
            element={<Navigate to='/all-programmes' />}
          />
          <Route
            path={'/contact-us'}
            element={
              <RouteMatch>
                <ContactUs />
              </RouteMatch>
            }
          />
         
          <Route
            path={'/course-generator'}
            element={
              <RouteMatch>
                <CourseGenerator />
              </RouteMatch>
            }
          />
          <Route
            path={'/scholarships'}
            element={
              <RouteMatch>
                <FinancialAidScholarship />
              </RouteMatch>
            }
          />
          <Route
            path={'/news-events'}
            element={
              <RouteMatch>
                <News />
              </RouteMatch>
            }
          />
          <Route
            path={'/news-events/media-coverage'}
            element={
              <RouteMatch>
                <MediaCoverage />
              </RouteMatch>
            }
          />
          <Route
            path={routes.campusLife.main}
            element={
              <RouteMatch>
                <CampusLife />
              </RouteMatch>
            }
          >
            <Route
              path={routes.campusLife.kshasCampus}
              element={
                <RouteMatch>
                  <CampusLife />
                </RouteMatch>
              }
            />
          </Route>
          <Route
            path={'/our-people'}
            element={
              <RouteMatch>
                <OurPeoples />
              </RouteMatch>
            }
          />
          {/* <Route path={"/our partners"} element={<OurPartners />} /> */}
          <Route
            path={'/all-programmes'}
            element={
              <RouteMatch>
                <AllProgrammes />
              </RouteMatch>
            }
          />
          <Route
            path={'/alumni-relations-career'}
            element={
              <RouteMatch>
                <OurAlumniAndCommunities />
              </RouteMatch>
            }
          />
          <Route
            path={'/international-office'}
            element={
              <RouteMatch>
                <InternationalOffices />
              </RouteMatch>
            }
          />
          {/* <Route
            path={'/international-office'}
            element={<MaintenancePage />}
          /> */}
          <Route
            path={'/about'}
            element={
              <RouteMatch>
                <About />
              </RouteMatch>
            }
          />
          <Route
            path='/vacancies'
            element={
              <RouteMatch>
                <Vacancies />
              </RouteMatch>
            }
          />
          <Route
            path='/academic-calendar'
            element={
              <RouteMatch>
                <AcademicCalendar />
              </RouteMatch>
            }
          />
          <Route
            path='/admission'
            element={
              <RouteMatch>
                <Admission />
              </RouteMatch>
            }
          />
          <Route
            path='/odl'
            element={
              <RouteMatch>
                <Odl />
              </RouteMatch>
            }
          />
          <Route
            path='/odl-programmes/'
            element={
              <RouteMatch>
                <OdlProgrammes />
              </RouteMatch>
            }
          />
          <Route
            path='/training-services'
            element={
              <RouteMatch>
                <TrainingAndServices />
              </RouteMatch>
            }
          />

          <Route
            path='/training-services/rental-facilities'
            element={
              <RouteMatch>
                <RentalFacilities />
              </RouteMatch>
            }
          />
          {/* <Route
            path='/training-services'
            element={<Navigate to={'/training-services'} />}
          /> */}
          <Route
            path='/training-services/:name'
            element={
              <RouteMatch>
                <TrainingServicesPages />
              </RouteMatch>
            }
          />

          <Route
            path='/training-services/bem-gap'
            element={
              <RouteMatch>
                <BemGap />
              </RouteMatch>
            }
          />
          <Route
            path='/research'
            element={
              <RouteMatch>
                <Research />
              </RouteMatch>
            }
          />
          <Route
            path='/research/:name'
            element={
              <RouteMatch>
                <Irmc />
              </RouteMatch>
            }
          />
          {/* <Route path="/research/iepre" element={<Iepre />} /> */}

          <Route
            path='/college'
            element={<Navigate to={'/about?sideTab=8'} />}
          />
          <Route
            path='/college/:name'
            element={
              <RouteMatch>
                <NewCollege />
              </RouteMatch>
            }
          />
          <Route
            path={'/college/:name/cogs-student-guide'}
            element={
              <RouteMatch>
                <StudentGuide />
              </RouteMatch>
            }
          />
          <Route
            path='/faq'
            element={
              <RouteMatch>
                <Faq />
              </RouteMatch>
            }
          />
          <Route
            path='/ycu'
            element={
              <RouteMatch>
                <YayasanCanselor />
              </RouteMatch>
            }
          />

          <Route path='student-hub' element={<Outlet />}>
            <Route
              index
              element={
                <RouteMatch>
                  <Students />
                </RouteMatch>
              }
            />
            <Route
              path='announcements'
              element={
                <RouteMatch>
                  <Announcement />
                </RouteMatch>
              }
            />
            <Route
              path='quick-reference'
              element={
                <RouteMatch>
                  <Quick />
                </RouteMatch>
              }
            />
            <Route
              path='exam-timetable'
              element={
                <RouteMatch>
                  <Examination />
                </RouteMatch>
              }
            />
            <Route
              path='registrar-office'
              element={
                <RouteMatch>
                  <Registrar />
                </RouteMatch>
              }
            />
            <Route
              path='customer-satisfaction-index'
              element={
                <RouteMatch>
                  <CustomerSatisfaction />
                </RouteMatch>
              }
            />
            <Route
              path='student-representative-council'
              element={
                <RouteMatch>
                  <Council />
                </RouteMatch>
              }
            />
            <Route
              path='uniten-customer-centre-ucc'
              element={
                <RouteMatch>
                  <CustomerCentre />
                </RouteMatch>
              }
            />
            <Route
              path='uniten-smart-apps'
              element={
                <RouteMatch>
                  <SmartApps />
                </RouteMatch>
              }
            />
            <Route
              path='about-360-gem'
              element={
                <RouteMatch>
                  <GlobalExchange />
                </RouteMatch>
              }
            />
            <Route
              path='payment'
              element={
                <RouteMatch>
                  <Payment />
                </RouteMatch>
              }
            />
            <Route
              path='convocation'
              element={
                <RouteMatch>
                  <Convocation />
                </RouteMatch>
              }
            />
          </Route>
          <Route path='staff-hub' element={<Outlet />}>
            <Route
              index
              element={
                <RouteMatch>
                  <Staffs />
                </RouteMatch>
              }
            />
            <Route
              path='quick-reference'
              element={
                <RouteMatch>
                  <QuickStaff />
                </RouteMatch>
              }
            />
          </Route>

          <Route
            path='/search-results'
            element={
              <RouteMatch>
                <SearchResults />
              </RouteMatch>
            }
          />
          <Route path='/*' element={<PageNotFound />} />
        </Routes>
      </AnimatePresence>
      <SupportChat />
      <Footer />
    </div>
  )
}

export default Home
